import stockAlert from '@/api/inventory/stock-alert-setting'

export const state = {
  resources: []
}

export const getters = {}

export const mutations = {
  RECEIVE_RESOURCES(state, data) {
    state.resources = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    return stockAlert.get().then(response => {
      context.commit('RECEIVE_RESOURCES', response.data)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return stockAlert.store(data)
  }
}
